import { marked } from "marked";
import TurndownService from "turndown";

/* ── marked: markdown → HTML ── */
marked.setOptions({
  breaks: true,       // single newlines become <br>
  gfm: true,          // GitHub-flavoured markdown
});

/** Convert markdown string to HTML for the contentEditable editor */
export function mdToHtml(md) {
  if (!md) return "";
  return marked.parse(md);
}

/* ── turndown: HTML → markdown ── */
const td = new TurndownService({
  headingStyle: "atx",          // # style headings
  bulletListMarker: "-",
  emDelimiter: "*",
  strongDelimiter: "**",
  br: "\n",
});

// Preserve first-line paragraph indentation (set via textIndent CSS by the
// Tab-key handler) as leading em-space characters so the indent survives the
// markdown round-trip.  One em-space ( ) per 32 px of indent.
const TAB_STEP_PX = 32;
td.addRule('paragraph-with-indent', {
  filter: (node) => node.nodeName === 'P' && !!(node.style && node.style.textIndent),
  replacement: (content, node) => {
    const indent = parseFloat(node.style.textIndent) || 0;
    const steps = Math.max(0, Math.round(indent / TAB_STEP_PX));
    const prefix = '\u2003'.repeat(steps); // em-space
    return '\n\n' + prefix + content.trim() + '\n\n';
  },
});

// Canonical newline rule: every line break — a lone "\n" or a run of
// several blank lines — becomes exactly one blank line ("\n\n"), i.e. every
// line break is a paragraph break. Keeps web/desktop/mobile saving the exact
// same on-disk format regardless of how the underlying HTML was structured.
function normalizeNewlines(md) {
  return md
    .replace(/\r\n/g, "\n")
    .replace(/[ \t]+$/gm, "")
    .replace(/\n+/g, "\n\n")
    .trim();
}

/** Convert the editor's innerHTML back to markdown for storage */
export function htmlToMd(html) {
  if (!html) return "";
  return normalizeNewlines(td.turndown(html));
}
